<template>
    <div class="PromotionCard" :style="`border-color: ${themeColor}`">
        <div class="PromotionCard__in">
            <div class="PromotionCard__left">
                <div class="tags" :style="`border-color: ${themeColor}; color: ${themeColor}`">
                    <ABadge v-for="tag in data.tags">
                        {{ tag }}
                    </ABadge>
                </div>
                <div class="PromotionCard__title">
                  <span :style="`color: ${themeColor}`">{{data.titleColored}}</span>
                  {{ data.title }}
                </div>
                <div class="PromotionCard__description" v-html="data.description"></div>
                <ABtn v-if="data.btn?.title&&data.btn?.link" color="#fff" :bg="themeColor" :href="data.btn?.link" :label="data.btn?.title"/>
            </div>
            <div class="PromotionCard__right" :class="data.video ? ' withVideo' : '' ">
              <div class="video-container" v-if="data.video">
                  <iframe
                      :src="videoUrl"
                      title="YouTube Video Player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                  ></iframe>
                </div>
                <img v-else :src="data.img.src" :alt="data.img.alt" :title="data.img.title">
            </div>
        </div>
    </div>
</template>

<script>
//пример https://i.imgur.com/yB3NPCH.png
import {ABadge, ABtn} from '../ui'

export default {
    name: "PromotionCard",
    props: {
        data: {
            // Заголовок, текст, теги..
            type: Object,
            default: () => ({
                titleColored:'НКО: ConnectEd',
              btn:{},
                title: `<span style="color: #A4AADA">НКО: ConnectEd</span>Cбор и распространение компьютерной техники🤝`,
                description: `Наша команда — это профессионалы, отвечающие за развитие фонда и качественное выполнение задач.
                 Сотрудники имеют разные зоны ответственности: административное управление, подготовка, контроль.🤝🔥`,
                tags: ['Дедлайн: 22 марта 2023', 'Казахстан'],
                img: '/local/templates/main/img/content/article-3.jpg'
            })
        },
        themeColor: {
            // hex color of buttons and border
            type: String,
            default: '#A4AADA'
        }
    },
    computed: {
      videoUrl() {
        return 'https://www.youtube.com/embed/' + this.data.video;
      }
    },
    components: {ABadge, ABtn}
}
</script>
<style lang="scss">
.a-badge-value {
  white-space: break-spaces;
}
</style>
<style scoped lang="scss">
.PromotionCard {
    border: 3px solid var(--c-secondary-300);
    border-radius: 6px;
    background-color: #fff;
    padding: 10px;
    width: 100%;
    align-items: center;
    display: flex;

    &__in {
        display: flex;
        justify-content: space-between;
        @include tablet {
          //display: block;
          flex-direction: column;
          height: 100%;
        }
    }

    &__left {
        padding: 30px;
        display: flex;
        flex-direction: column;

    }

    &__right {
        max-width: 383px;
        flex: 1 0 383px;

        @include tablet {
          max-width: 100%;
          padding: 30px;
          padding-top: 0;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    &__right.withVideo {
      max-width: 51%;
      flex: 1 0 51%;

      @include tablet {
        max-width: 100%;
      }

      .video-container,
      .video-container iframe {
        width: 100%;
        height: 100%;
      }
    }

    &__title {
        font-weight: 600;
        font-size: 32px;
        line-height: 38px;
        margin-bottom: 25px;
        @include tablet {
          font-size: 22px;
          line-height: 28px;
        }
    }

    &__description {
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;
        margin-bottom: 25px;

      @include tablet {
        font-size: 14px;
        line-height: 20px;
      }
    }

    .tags {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 25px;
        gap: 15px;
    }

    ::v-deep .a-btn{
        width: max-content;
    }
}
</style>